import api from 'common/api'

export type Invite = {
  inviterFirstName: string
  inviterLastName: string
  inviterEmail: string
  inviterAvatarUrl?: string
  inviterId: string
}

export type Inviters = {
  inviters: Invite[]
}

const getInviters = () => api.get<Inviters>('/api/student/relate/pending')

const invitationService = {
  getInviters,
}

export default invitationService
